import React from "react";
import { useState } from "react";
import ReactDOM from "react-dom";
import {
  HashRouter as Router,
  Route,
  Link,
  Switch,
  NavLink,
} from "react-router-dom";

const App = () => {
  const quotationsTab = [
    "Mamy jeszcze dużo czasu.",
    "Nie, nie, nie, nie, nie!",
    "To się zrobi później",
    "Przyjmuję to do wiadomości",
    "Napisałem taki program",
    "Do tego będzie program",
    "To jest niedopuszczalne.",
    "MAŁGOSIA!",
    "Proszę mi tu zawołać Sławka",
    "I z czego ja mam wam teraz zapłacić?!",
    "Nie. Znaczy tak, ale nie.",
    "To chyba jest jakiś ponury żart",
    "Wy mnie chcecie do więzienia wsadzić",
    "Dobrze, ale niedobrze",
    "Asia już jest?!",
    "Kto za to zapłaci?!",
    "Jutro wydajemy projekt, a nic nie mamy!",
    "Gdzie jest Daniel?! Musimy się przygotować",
    "Ja zaraz wyjeżdzam, gdzie jest Daniel?",
    "Małgosia zrób mi kawę",
    "Teraz mamy kryzys",
    "Założenia będą później, proszę rysować",
    "Gdzie jest Asia?!",
    "Małgosia, głodny jestem",
    "Asia ma to już policzone",
    "Budowa czeka",
    "Nie spałem całą noc",
    "Co jeszcze?!",
    "Mamy sobotę, mamy niedzielę",
    "Ja siedziałem cały weekend",
    "Wiem, ale nie powiem",
    "Małgosia, idź z tym telefonem, my tu mamy naradę",
    "Wszystkie ręce na pokład",
    "Jak idzie?",
    "Robicie, robicie, a efektów jak nie było tak nie ma",
  ];

  const [quotation, setQuotation] = useState(
    quotationsTab[Math.floor(Math.random() * (quotationsTab.length - 0)) + 0]
  );
  const handleRandom = () => {
    setQuotation(
      quotationsTab[Math.floor(Math.random() * (quotationsTab.length - 0)) + 0]
    );
  };

  return (
    <>
      <div className="container">
        <div className="content">
          <div>
            <header>
              <h1>
                Pan Jacek <span>na dziś</span>
              </h1>
            </header>
            <section className="main">
              <h1>"{quotation}"</h1>
              <button onClick={handleRandom}>Losuj</button>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
